import React from "react";
import clsx from "clsx";
import { Button } from "@mui/material";
import { ExerciseAssetSort } from "@growth-machine-llc/stridist-api-client";
import FiltersArrowsSort from "../../coach-clients/FiltersArrowsSort";
import makeStyles from "@mui/styles/makeStyles";
import { ButtonProps } from "@ariakit/react";

interface NameSortButtonProps extends ButtonProps {
  sortKey: ExerciseAssetSort;
  onChangeSortKey?: (sortKey: ExerciseAssetSort) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "bold",
    fontSize: 15,
    color: theme.palette.text.primary,
  },

  active: {
    color: theme.palette.primary.main,
  },

  inactive: {
    color: theme.palette.text.primary,
  },
}));

export const NameSortButton = (props: NameSortButtonProps) => {
  const { sortKey, onChangeSortKey, className, ...other } = props;
  const s = useStyles();
  const isActiveAsc = sortKey === ExerciseAssetSort.NAME_ASC;
  const isActiveDesc = sortKey === ExerciseAssetSort.NAME_DESC;
  const isActive = isActiveAsc || isActiveDesc;
  const handleClick = () => {
    const nextSort =
      sortKey === ExerciseAssetSort.NAME_ASC
        ? ExerciseAssetSort.NAME_DESC
        : ExerciseAssetSort.NAME_ASC;

    onChangeSortKey?.(nextSort);
  };

  return (
    <Button
      className={clsx(s.root, className, {
        [s.active]: isActive,
      })}
      children="Name"
      endIcon={
        <FiltersArrowsSort activeUp={isActiveAsc} activeDown={isActiveDesc} />
      }
      onClick={handleClick}
    />
  );
};
